<template>
  <span>
    <span v-for="(chunk, i) in chunks" :key="chunk.key">
      <span class="highlight" v-if="chunk.match">{{ chunk.text }}</span>
      <span v-else>{{ chunk.text }}</span>
    </span>
  </span>
</template>

<script>
import highlightWords from 'highlight-words';

export default {
  props: {
    text: {
      type: String,
      default: '',
    },

    query: {
      type: String,
      default: '',
    },
  },

  data() {
    return {};
  },

  computed: {
    chunks() {
      return highlightWords({
        text: this.text,
        matchExactly: false,
        query: this.query,
      });
    },
  },
};
</script>

<style scoped>
.highlight {
  background-color: yellow;
}
</style>
